import {
  CloseCircleOutlined,
  CloudUploadOutlined,
  FileOutlined
} from '@ant-design/icons';
import { Button, Typography, Upload } from 'antd';
import styled from 'styled-components';

import { BlueColors, GreenColors, NeutralColors } from '@/theme';

const { Dragger } = Upload;

export const StyledDragger = styled(Dragger)`
  height: 100%;
  &.panorama-upload-drag {
    background-color: ${NeutralColors[10]} !important;
    border: 2px dashed ${NeutralColors[30]} !important;
    border-radius: 3px;
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;

    &:hover,
    &.panorama-upload-drag-hover {
      border-color: ${BlueColors[60]} !important;
      border-width: 2px !important;
      background-color: ${BlueColors[10]} !important;
    }

    .panorama-upload-btn {
      background-color: transparent !important;
    }

    .panorama-upload-drag-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 40px 24px;
    }
  }
`;

export const UploadIcon = styled(CloudUploadOutlined)`
  font-size: 48px;
  color: ${BlueColors[60]};
  display: block;
  margin-bottom: 4px;
`;

export const DropZoneTextRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 4px;
`;

export const DropZoneText = styled(Typography.Text)`
  font-size: 14px;
  font-weight: 600;
  color: ${NeutralColors[100]};
`;

export const BrowseButton = styled(Button)`
  &.panorama-btn-link {
    color: ${GreenColors[60]};
    font-size: 14px;
    font-weight: 600;
    padding: 0;
    height: auto;
    line-height: inherit;
  }
`;

export const SupportedFormats = styled(Typography.Text)`
  font-size: 12px;
  color: ${NeutralColors[60]};

  strong {
    font-weight: 600;
    color: ${NeutralColors[60]};
  }
`;

export const FileInfoWrapper = styled.div`
  padding-bottom: 50px;
`;

export const ReadyToUploadText = styled(Typography.Text)`
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid ${BlueColors[20]};
  border-radius: 8px;
  background-color: ${BlueColors[10]};
`;

export const FileNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileIcon = styled(FileOutlined)`
  font-size: 16px;
  color: ${NeutralColors[60]};
`;

export const FileName = styled(Typography.Text)`
  font-size: 12px;
`;

export const FileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileSize = styled(Typography.Text)`
  color: ${NeutralColors[50]};
  font-size: 12px;
  background-color: ${NeutralColors[10]};
  padding-inline: 8px;
  border-radius: 2px;
`;

export const RemoveFileIcon = styled(CloseCircleOutlined)`
  color: ${NeutralColors[60]};
  cursor: pointer;
  font-size: 16px;
`;
